import { useCallback, useMemo, useState } from 'react'
import {
  RevenueWaterfallSortBy,
  RevenueWaterfallSortDirection
} from '../content/RevenueWaterfallTable/types'

export type RevenueWaterfallSortState = {
  sortBy: RevenueWaterfallSortBy
  sortDirection: RevenueWaterfallSortDirection
}

const DEFAULT_SORT: RevenueWaterfallSortState = {
  sortBy: 'label',
  sortDirection: 'ASC'
}

export const useRevenueWaterfallSorting = () => {
  const [sortState, setSortState] =
    useState<RevenueWaterfallSortState>(DEFAULT_SORT)

  const sortParams = useMemo(() => {
    const sortBy = sortState.sortBy

    if (!sortBy) {
      return DEFAULT_SORT
    }

    return {
      sortBy,
      sortDirection: sortState.sortDirection
    } as const
  }, [sortState.sortBy, sortState.sortDirection])

  const handleSort = useCallback((sortBy: RevenueWaterfallSortBy) => {
    setSortState(prev => {
      if (prev.sortBy === sortBy) {
        return {
          sortBy: sortBy,
          sortDirection: prev.sortDirection === 'ASC' ? 'DESC' : 'ASC'
        }
      }

      return {
        sortBy: sortBy,
        sortDirection: 'DESC'
      }
    })
  }, [])

  return {
    sortParams,
    handleSort
  }
}
